/**
 * Pitch-Berechnung für Kamera-Modi.
 * Reine Funktion — keine Abhängigkeiten außer Config.
 */
import type { CameraConfig } from '../config/CameraConfig';
import { CameraMode } from './CameraMode';

export function pitchForMode(
  mode: CameraMode,
  zoom: number,
  cfg: CameraConfig,
): number {
  if (mode === CameraMode.FlightView) {
    const fv = cfg.flightView;
    const t = Math.max(0, Math.min(1, (zoom - fv.zoomMin) / (fv.zoomMax - fv.zoomMin)));
    return fv.pitchAtMinZoom + t * (fv.pitchAtMaxZoom - fv.pitchAtMinZoom);
  }
  const t = Math.max(0, Math.min(1, (zoom - cfg.zoomMin) / (cfg.zoomMax - cfg.zoomMin)));
  return cfg.pitchAtMinZoom + t * (cfg.pitchAtMaxZoom - cfg.pitchAtMinZoom);
}
